import { Spin } from "antd";
import styles from "./Accounts.module.css";


export const AuthLoading = () => {
    return (
        <div className={`${styles.container} fade-in`}>
            <Spin size="large" style={{ width: "100%", textAlign: "center" }} />
        </div>
    );
};
